module.exports = __webpack_public_path__ + "img/plat_logo.d6439635.png";